<template>
  <div class="container-club">
    <!-- 头部banner -->
    <div class="jdian-content-8">
      <div class="join-bg">
        <div class="container wow animate__animated animate__fadeInRight">
          <strong>加盟璟点台球</strong>
          <span>和我们一起做一个伟大的事业</span>
        </div>
      </div>
    </div>

    <!-- 标签页容器 -->
    <div class="tabs-container">
      <el-tabs
          type="border-card"
          class="large-tab-header"
          @tab-click="handleTabClick"
          v-model="activeTab"
      >
        <!-- 俱乐部加盟申请 -->
        <el-tab-pane label="俱乐部加盟申请" name="club">
          <div class="container join-application">
            <div class="join-form">
<!--              <div class="error-tips" v-if="Object.keys(errors).length">-->
<!--                {{ Object.values(errors)[0] }}-->
<!--              </div>-->

              <div class="form-group">
                <span class="form-label">姓名：</span>
                <el-input
                    type="text"
                    v-model="clubForm.userName"
                    :disabled="loading"
                    placeholder="请输入您的姓名"
                    class="form-input"
                />
              </div>

              <div class="form-group">
                <span class="form-label">联系方式：</span>
                <el-input
                    type="text"
                    v-model="clubForm.userMobile"
                    maxlength="11"
                    :disabled="loading"
                    placeholder="请输入11位手机号"
                    class="form-input"
                />
              </div>

              <div class="form-group message">
                <span class="form-label">行业认知：</span>
                <el-input
                    type="textarea"
                    v-model="clubForm.userExperience"
                    placeholder="请您简单讲讲对台球行业的认知..."
                    :disabled="loading"
                    :rows="isMobile ? 3 : 3"
                    class="form-textarea"
                />
              </div>

              <div class="form-group">
                <span class="form-label">投资城市：</span>
                <div class="city-select-group">
                  <el-select
                      v-model="clubForm.province"
                      placeholder="选择省份"
                      @change="updateCityList"
                      :disabled="loading"
                      class="province-select form-select"
                  >
                    <el-option
                        v-for="item in provinces"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name"
                    ></el-option>
                  </el-select>
                  <el-select
                      v-model="clubForm.city"
                      placeholder="选择城市"
                      :disabled="!clubForm.province || loading"
                      class="city-select form-select"
                  >
                    <el-option
                        v-for="item in cityList"
                        :key="item"
                        :label="item"
                        :value="item"
                    ></el-option>
                  </el-select>
                </div>
              </div>

              <div class="form-group radio-group">
                <span class="form-label">投资预算：</span>
                <div class="radio-list">
                  <label
                      v-for="money in budgetOptions"
                      :key="`club-money-${money.value}`"
                      class="radio-item"
                  >
                    <input
                        type="radio"
                        v-model="clubForm.userJoinMoney"
                        :value="money.value"
                        :disabled="loading"
                    > {{ money.label }}
                  </label>
                </div>
              </div>

              <div class="form-group radio-group">
                <span class="form-label">投资面积：</span>
                <div class="radio-list">
                  <label
                      v-for="area in areaOptions"
                      :key="`club-area-${area.value}`"
                      class="radio-item"
                  >
                    <input
                        type="radio"
                        v-model="clubForm.acreage"
                        :value="area.value"
                        :disabled="loading"
                    > {{ area.label }}
                  </label>
                </div>
              </div>

              <div class="form-submit">
                <el-button
                    type="primary"
                    @click="handleClubSubmit"
                    :loading="loading"
                    class="submit-btn"
                >
                  提交申请
                </el-button>
              </div>
              <div class="error-tips" v-if="Object.keys(errors).length">
                {{ Object.values(errors)[0] }}
              </div>
            </div>
          </div>
        </el-tab-pane>

        <!-- 器材店加盟申请 -->
        <el-tab-pane label="器材店加盟申请" name="qc">
          <div class="container join-application">
            <div class="join-form">
<!--              <div class="error-tips" v-if="Object.keys(errors).length">-->
<!--                {{ Object.values(errors)[0] }}-->
<!--              </div>-->

              <div class="form-group">
                <span class="form-label">姓名：</span>
                <el-input
                    type="text"
                    v-model="qcForm.userName"
                    :disabled="loading"
                    placeholder="请输入您的姓名"
                    class="form-input"
                />
              </div>

              <div class="form-group radio-group">
                <span class="form-label">性别：</span>
                <div class="radio-list">
                  <label
                      v-for="sexItem in sexOption"
                      :key="`qc-sex-${sexItem.value}`"
                      class="radio-item"
                  >
                    <input
                        type="radio"
                        v-model="qcForm.userSex"
                        :value="sexItem.value"
                        :disabled="loading"
                    > {{ sexItem.label }}
                  </label>
                </div>
              </div>

              <div class="form-group">
                <span class="form-label">联系方式：</span>
                <el-input
                    type="text"
                    v-model="qcForm.userMobile"
                    maxlength="11"
                    :disabled="loading"
                    placeholder="请输入11位手机号"
                    class="form-input"
                />
              </div>

              <div class="form-group">
                <span class="form-label">身份证号：</span>
                <el-input
                    type="text"
                    v-model="qcForm.userIdentity"
                    maxlength="18"
                    :disabled="loading"
                    placeholder="请输入18位身份证号"
                    class="form-input"
                />
              </div>

              <div class="form-group">
                <span class="form-label">通讯地址：</span>
                <el-input
                    type="text"
                    v-model="qcForm.userAddress"
                    :disabled="loading"
                    placeholder="请输入详细通讯地址"
                    class="form-input"
                />
              </div>

              <div class="form-group message">
                <span class="form-label">行业认知：</span>
                <el-input
                    type="textarea"
                    v-model="qcForm.userExperience"
                    placeholder="请您简单讲讲从业经验..."
                    :disabled="loading"
                    :rows="isMobile ? 3 : 3"
                    class="form-textarea"
                />
              </div>

              <div class="form-group radio-group">
                <span class="form-label">城市级别：</span>
                <div class="radio-list">
                  <label
                      v-for="item in userCityLeveOption"
                      :key="`qc-level-${item.value}`"
                      class="radio-item"
                  >
                    <input
                        type="radio"
                        v-model="qcForm.userCityLeve"
                        :value="item.value"
                        :disabled="loading"
                    > {{ item.label }}
                  </label>
                </div>
              </div>

              <div class="form-group radio-group">
                <span class="form-label">投资预算：</span>
                <div class="radio-list">
                  <label
                      v-for="item in userJoinMoneyOption"
                      :key="`qc-money-${item.value}`"
                      class="radio-item"
                  >
                    <input
                        type="radio"
                        v-model="qcForm.userJoinMoney"
                        :value="item.value"
                        :disabled="loading"
                    > {{ item.label }}
                  </label>
                </div>
              </div>

              <div class="form-submit">
                <el-button
                    type="primary"
                    @click="handleQcSubmit"
                    :loading="loading"
                    class="submit-btn"
                >
                  提交申请
                </el-button>
              </div>
              <div class="error-tips" v-if="Object.keys(errors).length">
                {{ Object.values(errors)[0] }}
              </div>
            </div>
          </div>
        </el-tab-pane>

        <!-- 设计服务申请 -->
<!--        <el-tab-pane label="设计服务申请" name="design">-->
<!--          <div class="container join-application">-->
<!--            <div class="join-form">-->
<!--&lt;!&ndash;              <div class="error-tips" v-if="Object.keys(errors).length">&ndash;&gt;-->
<!--&lt;!&ndash;                {{ Object.values(errors)[0] }}&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->

<!--              <div class="form-group">-->
<!--                <span class="form-label">所在城市：</span>-->
<!--                <el-input-->
<!--                    type="text"-->
<!--                    v-model="designForm.city"-->
<!--                    :disabled="loading"-->
<!--                    placeholder="请输入所在城市"-->
<!--                    class="form-input"-->
<!--                />-->
<!--              </div>-->

<!--              <div class="form-group">-->
<!--                <span class="form-label">店号：</span>-->
<!--                <el-input-->
<!--                    type="text"-->
<!--                    v-model="designForm.dianhao"-->
<!--                    :disabled="loading"-->
<!--                    placeholder="请输入店号"-->
<!--                    class="form-input"-->
<!--                />-->
<!--              </div>-->

<!--              <div class="form-group">-->
<!--                <span class="form-label">联系人：</span>-->
<!--                <el-input-->
<!--                    type="text"-->
<!--                    v-model="designForm.username"-->
<!--                    :disabled="loading"-->
<!--                    placeholder="请输入联系人姓名"-->
<!--                    class="form-input"-->
<!--                />-->
<!--              </div>-->

<!--              <div class="form-group">-->
<!--                <span class="form-label">电话：</span>-->
<!--                <el-input-->
<!--                    type="text"-->
<!--                    v-model="designForm.phone"-->
<!--                    maxlength="11"-->
<!--                    :disabled="loading"-->
<!--                    placeholder="请输入11位手机号"-->
<!--                    class="form-input"-->
<!--                />-->
<!--              </div>-->

<!--              <div class="form-group checkbox-group">-->
<!--                <span class="form-label">设计类型：</span>-->
<!--                <div class="checkbox-list">-->
<!--                  <label class="checkbox-item" v-for="type in designTypeOptions" :key="`design-type-${type.value}`">-->
<!--                    <input-->
<!--                        type="checkbox"-->
<!--                        name="designType"-->
<!--                        :value="type.value"-->
<!--                        :checked="designForm.designType.includes(type.value)"-->
<!--                        @change="updateDesignType"-->
<!--                        :disabled="loading"-->
<!--                    > {{ type.label }}-->
<!--                  </label>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="form-group message">-->
<!--                <span class="form-label">设计要求：</span>-->
<!--                <el-input-->
<!--                    type="textarea"-->
<!--                    v-model="designForm.designRequest"-->
<!--                    placeholder="使用场景、设计尺寸、风格要求等..."-->
<!--                    :disabled="loading"-->
<!--                    :rows="isMobile ? 3 : 3"-->
<!--                    class="form-textarea"-->
<!--                />-->
<!--              </div>-->

<!--              <div class="form-group message">-->
<!--                <span class="form-label">赛事活动：</span>-->
<!--                <el-input-->
<!--                    type="textarea"-->
<!--                    v-model="designForm.gameInfo"-->
<!--                    placeholder="填写赛事相关的规程信息（非赛事类可不填）"-->
<!--                    :disabled="loading"-->
<!--                    :rows="isMobile ? 3 : 3"-->
<!--                    class="form-textarea"-->
<!--                />-->
<!--              </div>-->

<!--              <div class="form-submit">-->
<!--                <el-button-->
<!--                    type="primary"-->
<!--                    @click="handleDesignSubmit"-->
<!--                    :loading="loading"-->
<!--                    class="submit-btn"-->
<!--                >-->
<!--                  提交申请-->
<!--                </el-button>-->
<!--              </div>-->
<!--              <div class="error-tips" v-if="Object.keys(errors).length">-->
<!--                {{ Object.values(errors)[0] }}-->
<!--              </div>-->

<!--              <div class="remarks">-->
<!--                <p class="remarks-title">备注：</p>-->
<!--                <ul class="remarks-list">-->
<!--                  <li>1.简单的修改内容等问题，可直接与设计沟通，如果修改的范围和内容过多，请重新提报表格；</li>-->
<!--                  <li>2.赛事及赛事有关的需求，请于开赛前一个月提供此表格，其余类型请提前1周提供；</li>-->
<!--                  <li>3.图片基本在一周内设计完成，特殊情况，视情况而定；</li>-->
<!--                  <li>4.设计的工作过多时可能会有所延误，如不能按时完成，会及时与各位同盟商提前说明，请理解，谢谢。</li>-->
<!--                  <li>5.与璟点无关赛事，公司不提供设计帮助，还望见谅！</li>-->
<!--                </ul>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </el-tab-pane>-->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { PROVINCE_DATA } from "@/enums/provinceCityEnum";
import { joinUsApply, joinUsClub, joinUsDesign } from "@/api/home";

export default {
  name: 'Join',
  data() {
    return {
      activeTab: 'club',
      loading: false,
      errors: {},
      provinces: PROVINCE_DATA,
      cityList: [],
      isMobile: false,
      // 俱乐部加盟表单
      clubForm: {
        userName: '',
        userMobile: '',
        userExperience: '',
        province: '',
        city: '',
        userJoinMoney: '',
        acreage: '',
      },
      // 器材店加盟表单
      qcForm: {
        userName: '',
        userSex: '',
        userMobile: '',
        userIdentity: '',
        userAddress: '',
        userExperience: '',
        userCityLeve: '',
        userJoinMoney: '',
      },
      // 设计服务表单
      designForm: {
        city: '',
        dianhao: '',
        username: '',
        phone: '',
        designType: [],
        designRequest: '',
        gameInfo: '',
      },
      // 选项配置
      sexOption: [
        { label: '男', value: '1' },
        { label: '女', value: '0' },
      ],
      userCityLeveOption: [
        { label: '省会城市', value: '3' },
        { label: '直辖区', value: '4' },
        { label: '地级城市', value: '2' },
        { label: '县级城市', value: '1' },
      ],
      userJoinMoneyOption: [
        { label: '50万元以内', value: '5' },
        { label: '50-100万元', value: '6' },
        { label: '100-200万元', value: '7' },
        { label: '300万元以上', value: '8' },
      ],
      budgetOptions: [
        { label: '10-30万', value: '10-30万' },
        { label: '31-80万', value: '31-80万' },
        { label: '81-130万', value: '81-130万' },
        { label: '131-180万', value: '131-180万' },
        { label: '181万以上', value: '181万以上' },
      ],
      areaOptions: [
        { label: '100~300m²', value: '100~300m²' },
        { label: '301~500m²', value: '301~500m²' },
        { label: '501~700m²', value: '501~700m²' },
        { label: '701~1000m²', value: '701~1000m²' },
        { label: '1000m²以上', value: '1000m²以上' },
      ],
      designTypeOptions: [
        { label: '海报', value: '海报' },
        { label: '展架', value: '展架' },
        { label: '微信宣传图', value: '微信宣传图' },
        { label: '赛事', value: '赛事' },
        { label: '背景墙', value: '背景墙' },
        { label: '折页', value: '折页' },
        { label: '传单', value: '传单' },
        { label: '其他', value: '其他' },
      ],
    };
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
    // 移动端初始化时滚动到顶部
    if (this.isMobile) {
      window.scrollTo(0, 0);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    // 检测设备类型
    checkDevice() {
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      this.isMobile = isMobileDevice || window.innerWidth < 768;

      // 移动端额外优化：防止输入时页面缩放
      if (this.isMobile) {
        document.querySelector('meta[name="viewport"]')?.setAttribute(
            'content',
            'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
        );
      }
    },
    // 标签切换处理
    handleTabClick() {
      this.errors= {};
      if (this.isMobile) {
        const formElement = document.querySelector('.join-application');
        if (formElement) {
          formElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    },
    // 更新城市列表
    updateCityList() {
      const targetProvince = this.provinces.find((item) => item.name === this.clubForm.province);
      this.cityList = targetProvince ? targetProvince.cities : [];
      this.clubForm.city = "";
    },
    // 通用表单校验
    validateForm(form, rules) {
      this.errors = {};
      let isValid = true;
      for (const [field, message] of Object.entries(rules)) {
        if (!form[field]) {
          this.errors[field] = message;
          isValid = false;
        }
      }
      return isValid;
    },
    // 手机号校验
    validatePhone(phoneNumber) {
      const phoneRegex = /^1[3-9]\d{9}$/;
      return phoneRegex.test(phoneNumber);
    },
    // 身份证校验
    validateIdentity(id) {
      const idRegex = /^\d{17}[\dXx]$/;
      return idRegex.test(id);
    },
    // 俱乐部提交
    async handleClubSubmit() {
      const rules = {
        userName: '请输入您的姓名',
        userMobile: '请输入您的联系方式',
        userExperience: '请简单描述您对台球行业的认知',
        province: '请选择投资省份',
        city: '请选择投资城市',
        userJoinMoney: '请选择投资预算',
        acreage: '请选择投资面积',
      };
      if (!this.validateForm(this.clubForm, rules)) return;
      if (!this.validatePhone(this.clubForm.userMobile)) {
        this.errors.userMobile = '请输入有效的手机号';
        return;
      }

      this.loading = true;
      try {
        const payload = {
          ...this.clubForm,
          userJoinAddress: `${this.clubForm.province || ''}${this.clubForm.city || ''}`
        };
        const res = await joinUsClub(payload);
        if (res.code === 200) {
          this.$message.success('申请提交成功！我们会尽快与您联系。');
          this.resetForm('club');
        } else {
          this.$message.error(res.returnMsg || '提交失败，请稍后重试');
        }
      } catch (error) {
        this.$message.error('提交失败');
      } finally {
        this.loading = false;
      }
    },
    // 器材店提交
    async handleQcSubmit() {
      const rules = {
        userName: '请输入用户姓名',
        userSex: '请选择用户性别',
        userMobile: '请输入手机号码',
        userIdentity: '请输入身份证号',
        userAddress: '请输入联系地址',
        userExperience: '请输入从业经验',
        userCityLeve: '请选择城市等级',
        userJoinMoney: '请选择加盟金额',
      };
      if (!this.validateForm(this.qcForm, rules)) return;
      if (!this.validatePhone(this.qcForm.userMobile)) {
        this.errors.userMobile = '请输入有效的手机号';
        return;
      }
      if (!this.validateIdentity(this.qcForm.userIdentity)) {
        this.errors.userIdentity = '请输入有效的身份证号';
        return;
      }

      this.loading = true;
      try {
        const res = await joinUsApply(this.qcForm);
        if (res.code === 200) {
          this.$message.success('申请提交成功！我们会尽快与您联系。');
          this.resetForm('qc');
        } else {
          this.$message.error(res.returnMsg || '提交失败，请稍后重试');
        }
      } catch (error) {
        this.$message.error('提交失败');
      } finally {
        this.loading = false;
      }
    },
    // 设计服务提交
    async handleDesignSubmit() {
      const rules = {
        city: '请输入所在城市',
        dianhao: '请输入店号',
        username: '请输入联系人',
        phone: '请输入电话',
        designType: '请选择至少一种设计类型',
      };
      if (!this.validateForm(this.designForm, rules)) return;
      // 设计类型特殊校验
      if (!this.designForm.designType.length) {
        this.errors.designType = rules.designType;
        return;
      }
      if (!this.validateForm(this.designForm, rules)) return;
      if (!this.validatePhone(this.designForm.phone)) {
        this.errors.phone = '请输入有效的手机号';
        return;
      }

      this.loading = true;
      try {
        const payload = {
          ...this.designForm,
          designType: this.designForm.designType.join(',')
        };
        const res = await joinUsDesign(payload);
        if (res.code === 200) {
          this.$message.success('申请提交成功！我们会尽快与您联系。');
          this.resetForm('design');
        } else {
          this.$message.error(res.returnMsg || '提交失败，请稍后重试');
        }
      } catch (error) {
        this.$message.error('提交失败');
      } finally {
        this.loading = false;
      }
    },
    // 重置表单
    resetForm(formType) {
      if (formType === 'club') {
        Object.assign(this.clubForm, {
          userName: '', userMobile: '', userExperience: '', province: '', city: '', userJoinMoney: '', acreage: '',
        });
        this.cityList = [];
      } else if (formType === 'qc') {
        Object.assign(this.qcForm, {
          userName: '', userSex: '', userMobile: '', userIdentity: '', userAddress: '', userExperience: '', userCityLeve: '', userJoinMoney: '',
        });
      } else if (formType === 'design') {
        Object.assign(this.designForm, {
          city: '', dianhao: '', username: '', phone: '', designType: [], designRequest: '', gameInfo: '',
        });
      }
      this.errors = {};
    },
    // 更新设计类型复选框
    updateDesignType(event) {
      const checkbox = event.target;
      const value = checkbox.value;
      if (checkbox.checked) {
        if (!this.designForm.designType.includes(value)) {
          this.designForm.designType.push(value);
        }
      } else {
        this.designForm.designType = this.designForm.designType.filter(item => item !== value);
      }
    },
  },
};
</script>

<style scoped lang="scss">
// 响应式断点定义
$mobile: 768px;
$small-mobile: 480px;
$large-mobile: 576px;

.el-select-dropdown__item{
  @media (max-width: $mobile) {
    font-size: 12px !important;
    height: 15px !important;
    line-height: 15px !important;
  }
}

// 全局容器
.container-club {
  width: 100%;
  background: #ecebf0;
  margin-top: 100px;
  min-height: calc(100vh - 100px);

  @media (max-width: $mobile) {
    margin-top: 0;
    min-height: 100vh;
  }
}

// 头部Banner
.jdian-content-8 {
  width: 100%;

  .join-bg {
    background: url('../../../assets/img/club/club_bg_2.jpg') center no-repeat;
    padding: 4% 0;
    background-size: cover;
    width: 100%;

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
      @media (max-width: $mobile) {
        max-width:768px;
      }

      strong {
        position: relative;
        display: block;
        padding-top: 30px;
        font-size: 46px;
        letter-spacing: 10px;
        color: #f6c279;

        @media (max-width: $mobile) {
          padding-top: 0;
          font-size: 28px;
          letter-spacing: 4px;
          text-align: center;
        }

        &::before {
          position: absolute;
          content: '';
          top: 0;
          left: 0;
          width: 63px;
          border-top: 10px solid #f6c279;

          @media (max-width: $mobile) {
            border-top: 3px solid #f6c279;
          }
        }
      }

      span {
        display: block;
        font-size: 36px;
        color: #fff;
        letter-spacing: 6px;

        @media (max-width: $mobile) {
          font-size: 16px;
          letter-spacing: 2px;
          text-align: center;
          margin-top: 10px;
        }
      }
    }
  }
}

// 标签页容器
.tabs-container {
  max-width: 1200px;
  margin: 40px auto 0;
  padding: 0 20px 40px;

  @media (max-width: $mobile) {
    margin:auto 0;
    padding: 0 ;
    max-width:none;
  }
}

// 标签页样式优化
.large-tab-header {
  ::v-deep {
    .el-select-dropdown__item{
        font-size: 10px !important;
        height: 15px !important;
        line-height: 15px !important;
    }
    .el-select-dropdown{
        font-size: 10px !important;
    }
    .el-tabs__header {

      @media (max-width: $mobile) {
        background: #fff;
      }
    }

    .el-tabs__nav-scroll {
      @media (max-width: $mobile) {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        &::-webkit-scrollbar {
          display: none;
        }
      }
    }

    .el-tabs__nav {
      @media (max-width: $mobile) {
        white-space: nowrap;
        display: flex;
      }
    }

    .el-tabs__item {
      font-size: 18px;
      padding: 0 30px;
      height: 60px;
      line-height: 60px;
      font-weight: 600;
      color: #333;

      @media (max-width: $mobile) {
        padding: 0 20px;
        height: 50px;
        line-height: 50px;
        font-size: 12px;
        flex-shrink: 0;
      }

      @media (max-width: $small-mobile) {
        padding: 0 15px;
        font-size: 12px;
      }

      &:hover {
        color: #f4c078 !important;
      }

      &.is-active {
        color: #f4c078 !important;
        border-bottom: 4px solid #f4c078 !important;

        @media (max-width: $mobile) {
          border-bottom-width: 3px !important;
        }
      }
    }

    .el-tabs__content {
      background: #fff;
      padding: 40px;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

      @media (max-width: $mobile) {
        padding: 25px 20px;
        border-radius: 10px;
      }

      @media (max-width: $small-mobile) {
        padding: 20px 15px;
      }
    }
  }
}

// 表单容器
.join-application {
  padding: 10px 0;
}

// 表单样式
.join-form {
  max-width: 800px;
  margin: 0 auto;
  @media (max-width: $mobile) {
    max-width:none;
  }

  // 错误提示
  .error-tips {
    padding: 12px 20px;
    background: #fef0f0;
    color: #f56c6c;
    border-radius: 8px;
    margin-bottom: 25px;
    margin-top: 25px;
    font-size: 14px;
    border-left: 4px solid #f56c6c;

    @media (max-width: $mobile) {
      padding: 10px 15px;
      margin-bottom: 20px;
      font-size: 13px;
    }
  }

  // 表单组
  .form-group {
    margin-bottom: 25px;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;

    @media (max-width: $mobile) {
      margin-bottom: 20px;
      flex-direction: column;
      align-items: stretch;
    }

    .form-label {
      width: 120px;
      font-size: 16px;
      color: #333;
      font-weight: 500;
      padding-top: 10px;
      flex-shrink: 0;

      @media (max-width: $mobile) {
        width: 80px;
        padding-top: 0;
        margin-bottom: 8px;
        font-size: 14px;
      }
    }

    // 输入框样式
    .form-input {
      flex: 1;

      ::v-deep .el-input__inner {
        border: 1px solid #e0e0e0;
        font-size: 15px;
        height: 56px;
        line-height: 56px;
        padding: 0 20px;
        border-radius: 8px;
        transition: all 0.3s ease;

        @media (max-width: $mobile) {
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          //padding: 0 15px;
        }

        &:focus {
          border-color: #f4c078;
          box-shadow: 0 0 0 3px rgba(244, 192, 120, 0.2);
        }
      }

      ::v-deep .el-input.is-disabled .el-input__inner {
        background-color: #f8f9fa;
        border-color: #e9ecef;
        color: #6c757d;
      }
    }

    // 文本域样式
    &.message {
      .form-textarea {
        flex: 1;

        ::v-deep .el-textarea__inner {
          border: 1px solid #e0e0e0;
          font-size: 15px;
          padding: 15px;
          border-radius: 8px;
          line-height: 1.5;
          min-height: 120px;
          resize: vertical;

          @media (max-width: $mobile) {
            min-height: 100px;
            padding: 12px;
            font-size: 14px;
          }

          &:focus {
            border-color: #f4c078;
            box-shadow: 0 0 0 3px rgba(244, 192, 120, 0.2);
          }
        }
      }
    }

    // 城市选择组
    .city-select-group {
      flex: 1;
      display: flex;
      gap: 15px;

      @media (max-width: $mobile) {
        flex-direction: column;
        gap: 10px;
      }

      .form-select {
        flex: 1;

        @media (max-width: $mobile) {
          width: 100%;
        }

        ::v-deep .el-input__inner {
          height: 56px;
          line-height: 56px;

          @media (max-width: $mobile) {
            height: 40px;
            line-height: 40px;
            font-size: 14px;
          }
        }
      }
    }

    // 单选组
    &.radio-group {
      flex: 1;

      .radio-list {
        display: flex;
        flex-wrap: wrap;
        gap: 15px 30px;

        @media (max-width: $mobile) {
          gap: 12px;
        }

        @media (max-width: $small-mobile) {
          gap: 8px;
        }
      }

      .radio-item {
        display: flex;
        align-items: center;
        font-size: 15px;
        color: #555;
        cursor: pointer;
        user-select: none;
        @media (max-width: $small-mobile) {
          font-size: 14px;
        }

        input {
          margin-right: 8px;
          width: 18px;
          height: 18px;
          accent-color: #f4c078;
          cursor: pointer;
          @media (max-width: $small-mobile) {
            width: 14px;
            height: 14px;
            margin-right: 8px;
          }

          &:disabled {
            cursor: not-allowed;
            opacity: 0.6;
          }
        }

        &:hover {
          color: #f4c078;
        }
      }
    }

    // 复选组
    &.checkbox-group {
      flex: 1;

      .checkbox-list {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;

        @media (max-width: $small-mobile) {
          gap: 10px;
        }
      }

      .checkbox-item {
        display: flex;
        align-items: center;
        font-size: 15px;
        color: #555;
        cursor: pointer;
        user-select: none;

        @media (max-width: $small-mobile) {
          flex: 0 0 calc(50% - 5px);
          max-width: calc(50% - 5px);
          font-size: 14px;
        }

        input {
          margin-right: 8px;
          width: 18px;
          height: 18px;
          accent-color: #f4c078;
          cursor: pointer;
          @media (max-width: $small-mobile) {
            width: 14px;
            height: 14px;
          }

          &:disabled {
            cursor: not-allowed;
            opacity: 0.6;
          }
        }

        &:hover {
          color: #f4c078;
        }
      }
    }

    // 错误文本
    .error-text {
      color: #f56c6c;
      font-size: 13px;
      margin-top: 5px;
      display: block;
      width: 100%;
      padding-left: 120px;

      @media (max-width: $mobile) {
        padding-left: 0;
      }
    }
  }

  // 提交按钮
  .form-submit {
    text-align: center;
    margin-top: 40px;

    @media (max-width: $mobile) {
      margin-top: 30px;
    }

    .submit-btn {
      background: linear-gradient(135deg, #f4c078 0%, #e8b068 100%);
      border: none;
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      padding: 16px 60px;
      border-radius: 50px;
      transition: all 0.3s ease;
      box-shadow: 0 4px 15px rgba(244, 192, 120, 0.3);

      @media (max-width: $mobile) {
        width: 100%;
        padding: 14px 0;
        font-size: 16px;
      }

      &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(244, 192, 120, 0.4);
        background: linear-gradient(135deg, #e8b068 0%, #d9a258 100%);
      }

      &:active:not(:disabled) {
        transform: translateY(0);
        box-shadow: 0 2px 10px rgba(244, 192, 120, 0.3);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none !important;
      }
    }
  }

  // 备注信息
  .remarks {
    margin-top: 50px;
    @media (max-width: $mobile) {
      margin-top: 20px;
      font-size: 11px;
    }
    li{
      list-style-type: none;
      letter-spacing: 3px;
    }
  }
}
</style>